import request from 'api/requestUtils'
import { baseUri, getOptions } from 'tripPlanner/api/utils'
import type {
  WishlistDetail,
  WishlistIndex,
  WishlistResponse,
  WishlistSavePayload,
  WishlistSaveResult,
  WishlistSummary,
} from './types'

const wishlistUri = `${baseUri}/v2/wishlists`

export async function listWishlists(): Promise<WishlistIndex> {
  return request
    .get<WishlistResponse<WishlistIndex>>(wishlistUri, getOptions())
    .then((response) => response.result)
}

export async function getWishlist(wishlistId: string): Promise<WishlistDetail> {
  return request
    .get<WishlistResponse<WishlistDetail>>(`${wishlistUri}/${wishlistId}`, getOptions())
    .then((response) => response.result)
}

export async function createWishlist(name: string): Promise<WishlistSummary> {
  return request
    .post<WishlistResponse<WishlistSummary>, { name: string }>(
      wishlistUri,
      { name },
      getOptions(),
    )
    .then((response) => response.result)
}

export async function updateWishlist(
  wishlistId: string,
  name: string,
): Promise<WishlistSummary> {
  return request
    .patch<WishlistResponse<WishlistSummary>, { name: string }>(
      `${wishlistUri}/${wishlistId}`,
      { name },
      getOptions(),
    )
    .then((response) => response.result)
}

export async function saveWishlistOffer(
  payload: WishlistSavePayload,
): Promise<WishlistSaveResult> {
  return request
    .post<WishlistResponse<WishlistSaveResult>, WishlistSavePayload>(
      `${wishlistUri}/save`,
      payload,
      getOptions(),
    )
    .then((response) => response.result)
}

export async function removeWishlistItem(
  wishlistId: string,
  savedOfferId: string,
): Promise<void> {
  await request.delete<WishlistResponse<null>>(
    `${wishlistUri}/${wishlistId}/items/${savedOfferId}`,
    getOptions(),
  )
}

export async function removeWishlistSavedOffer(savedOfferId: string): Promise<void> {
  await request.delete<WishlistResponse<null>>(
    `${wishlistUri}/items/${savedOfferId}`,
    getOptions(),
  )
}

export async function deleteWishlist(wishlistId: string): Promise<void> {
  await request.delete<WishlistResponse<null>>(
    `${wishlistUri}/${wishlistId}`,
    getOptions(),
  )
}
